export { default as Layout } from "./components/layout.js";
export { default as ErrorComponent } from "./components/error.js";

export const components = [
	() => import("../routes/index.js")
];

export const routes = [
	{
		// index.svelte
		pattern: /^\/$/,
		parts: [
			{ i: 0 }
		]
	}
];